<template>
  <button class="button" @click="emitClick">
    {{ buttonName }}
  </button>
</template>

<script>
export default {
  name: 'CustomButton',

  props: {
    buttonName: String,
  },

  setup(props, { emit }) {
    function emitClick() {
      emit(`${props.buttonName}-click`);
    }

    return {
      emitClick,
    };
  },
};
</script>

<style lang="scss" scoped>
  .button {
    align-items: center;
    background-color: inherit;
    border: inherit;
    color: inherit;
    cursor: pointer;
    display: flex;
    font-size: inherit;
    height: inherit;
    justify-content: center;
    transition: ease-out 0.1s;
    width: inherit;
  }
  .button:active {
    transform: scale(0.95);
  }
</style>
